export default {"src":"/_next/static/media/pork.2c0d4079.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};